import { ICard } from '../../model/models/payment-methods';
import { IValidateCardResponseEntity } from '../../model/api/payment-accounts';
import { IPaymentProvider } from './payment.interface';

export class PaymentProviderCyberSource implements IPaymentProvider {
  getSignatureFields(model) {
    return {
      bill_to_forename: model.firstName,
      bill_to_surname: model.lastName,
      bill_to_address_country: model.country,
      bill_to_address_line1: model.street,
      bill_to_address_city: model.city,
      bill_to_address_state: model.stateProvince,
      bill_to_address_postal_code: model.postCode,
      payment_token_title: model.alias,
      unsigned_field_names: 'card_type,card_number,card_expiry_date,card_cvn,merchant_secure_data1'
    };
  }

  createRequest(card: ICard, response: IValidateCardResponseEntity) {
    const entity = { ...response.sourceSignature.signatureFields };
    for (const key in entity) {
      let value = entity[key];
      if (!value || value === 'null')
        value = '';
      entity[key] = value;
    }
    if (response.cardBrand === 'Maestro')
      entity.card_type = '042';
    else if (response.cardBrand === 'Visa')
      entity.card_type = '001';
    else
      entity.card_type = '002';

    entity.card_number = card.accountNumber;
    let month = card.expiryMonth.toString();
    if (month.length === 1) {
      month = `0${month}`;
    }
    entity.card_expiry_date =  month + '-' + card.expiryYear;
    entity.card_cvn = card.cvn;
    entity.merchant_secure_data1 = card.accountNumber.substr(0,6);
    entity.signature = response.sourceSignature.signature;

    return entity;
  }

  handleResponse(provider, response) {
    const el = document.createElement('div');
    el.innerHTML = response.responseData;
    let postdata = '';
    const postobject = {}
    const inputs = el.getElementsByTagName('input');
    for (let i=0; i < inputs.length; i++) {
      const input = inputs[i];
      if (i > 0) {
        postdata += '&';
      }
      postdata += encodeURIComponent(input.name) + '=' + encodeURIComponent(input.value);
      postobject[input.name] = input.value;
    }
    if (postobject['decision'] !== 'ACCEPT') {
      provider.logPaymentError('Cybersource card creation has been rejected', postobject);
      return null;
    }

    if (provider.platform.is('cordova'))
      return postobject;
    else
      return postdata;
  }

  async forwardResponse(provider, baseUrl, card: ICard, response): Promise<any> {
    const requestHeaders = {
      'Content-Type': 'application/x-www-form-urlencoded',
    };
    await provider.httpProvider.post(`${ baseUrl }account/card/silent-order-post`, response, null, requestHeaders);

    const addedCard = await this.checkAddedCard(provider, baseUrl, card, 5);
    return addedCard;
  }

  /**
   * @description Check if the card has been added
   */
  checkAddedCard(provider, baseUrl, card: ICard, tries: number = 1): Promise<Partial<ICard>> {
    return new Promise((resolve, reject) => {
      provider.httpProvider
        .get((`${ baseUrl }account/card/verify-card-addition`), {}, (res) => {
          if (res && res.toString().length > 0) {
            resolve(res);
          }
          else if (tries > 0) {
            window.setTimeout(() => {
              this.checkAddedCard(provider, baseUrl, card, (tries - 1))
                .then((res) => {
                  resolve(res);
                })
                .catch(() => {
                  reject();
                });
            }, 500);
          }
          else {
            reject();
          }
          return true;
        })
        .catch(() => {
          reject();
        });
    });
  }  

  clientSideAuthorization() {
    throw new Error('Client-side authorization not available for Cybersource');
  }
}



// WEBPACK FOOTER //
// ./src/providers/payment/payment.cybersource.ts